import Vue from 'vue';
import Moment from 'moment';

Vue.filter('moment', function (time, format) {
  if (Moment.isMoment(time)) {
    return time.format(format);
  } else if (time && time.timestamp) {
    return Moment(time.timestamp).format(format);
  }

  return Moment(time).format(format);
});
